module.exports = {
  "country": "RU",
  "artist": "Tatu",
  "song": "Ne wer, ne boisja",
  "year": "2003",
  "place": "3",
  "spotify": "4MuQWNaW51V9LRocFQUZRU"
};